import { render, staticRenderFns } from "./updatelocartionType.vue?vue&type=template&id=6a6fb9fa"
import script from "./updatelocartionType.vue?vue&type=script&lang=js"
export * from "./updatelocartionType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports